var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsTransformOutlineBrand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Transform") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.76,62.94A22.72,22.72,0,0,1,29.16,50.3V48.45h0l5.71,5.74a2,2,0,0,0,1.44.59,2,2,0,0,0,1.44-.59,2,2,0,0,0,0-2.88L27.13,40.66,16.59,51.2a2,2,0,1,0,2.88,2.87l5.62-5.62h0V50.3A26.78,26.78,0,0,0,74.35,64.87Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.24,36.06A22.72,22.72,0,0,1,74.84,48.7v1.85h0l-5.71-5.74a2,2,0,0,0-1.44-.59,2,2,0,0,0-1.44.59,2,2,0,0,0,0,2.88L76.87,58.34,87.41,47.8a2,2,0,1,0-2.88-2.87l-5.62,5.62h0V48.7A26.78,26.78,0,0,0,29.65,34.13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsTransformOutlineBrand);
export default __webpack_public_path__ + "static/media/Icons_Transform_Outline_Brand.7da63b72e773b1d1035876231425056e.svg";
export { ForwardRef as ReactComponent };